import { Outlet, useOutletContext } from 'react-router-dom'

import { ApprovalsGroupFragment } from 'generated/resources/graphql'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ApprovalRulePage = () => {
  const { group } = useOutletContext<{ group: ApprovalsGroupFragment }>()

  return (
    <ResponsivePage.Body showHeader={false}>
      <Outlet context={{ group }} />
    </ResponsivePage.Body>
  )
}

export default ApprovalRulePage
